import React from 'react';

import {HStack, Text, VStack} from "@chakra-ui/react";

import {useLanguage} from "@/contexts/languageContext";
import {Skeleton} from "@/components/ui";
import stringUtil from "@/utils/stringUtil";

export const ResourceCategoryBodySkeleton = ({props}) => {
    return <HStack
        gap="1vw"
        minH="3.5rem"
        maxH="6rem"
        overflow="hidden"
        flex={1}
        {...props}
    >
        <VStack align="flex-start" flex={1} overflow="hidden">
            <Skeleton>
                <Text
                    fontWeight="bold"
                    fontSize="md"
                    isTruncated
                >
                    { stringUtil.getRandomString(10, 25) }
                </Text>
            </Skeleton>
        </VStack>
    </HStack>
}

export const ResourceCategoryBody = ({element, ...props}) => {
    const {language, t} = useLanguage();

    return (
        <HStack
            gap="1vw"
            minH="3.5rem"
            maxH="6rem"
            color="secondary.500"
            overflow="hidden"
            {...props}
        >
            <VStack align="flex-start" flex={1} overflow="hidden">
                <Text
                    fontWeight="bold"
                    fontSize="md"
                    isTruncated
                >
                    { element?.[`${language}Label`] }
                </Text>
            </VStack>
        </HStack>
    );
};

export default ResourceCategoryBody;
